import React, { FunctionComponent } from "react";
import styles from "./ContactButton.module.css";

type props = {
  color: string;
  title: string;
  clicked: () => void;
  backgroundColor: string;
  disabled?: boolean;
};

const ContactButton: FunctionComponent<props> = ({ color, title, clicked,backgroundColor,disabled }) => {
  return (
    <div>
      <button
      disabled={disabled ? disabled : false}
        className={styles.button}
        style={{ color: color, borderColor: disabled ? "#d8d8d8" : backgroundColor,backgroundColor: disabled ? "#d8d8d8" : backgroundColor,fontWeight:"bold"}}
        onClick={clicked}
      >
        {title}
      </button>
    </div>
  );
};

export default ContactButton;
